export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BudgetTable.vue?vue&type=template&id=15b66dc4&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/CloseProject/BudgetTable.vue?vue&type=template&id=15b66dc4&scoped=true
// module id = 1986
// module chunks = 31